import { useQuery } from '@tanstack/react-query';

import { MbapiAdminService } from 'src/Services/API';

import { QueryKeys } from '../types';

export const useGetAllRoutes = () => {
  return useQuery([QueryKeys.getAllRoutes], async () => {
    return await MbapiAdminService.mbapiAdminControllerGetAllRoutes();
  });
};
